import { daysOfTheWeek } from "constants/daysOfTheWeek";
import moment from "moment";
import { toast, Slide } from "react-toastify";
import { setUser } from "redux/actions/userActions";
import { store } from "redux/store";

export function showToast(message, type = null) {
  toast(message, {
    type: type,
    theme: "colored",
    transition: Slide,
    position:
      window.innerWidth > 727
        ? toast.POSITION.BOTTOM_RIGHT
        : toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
  });
}

export function validateEmail(email) {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}

export function getUserToken() {
  const { token } = { ...store?.getState()?.user };
  return token;
}

export async function signOut() {
  store.dispatch(setUser({ token: null, user: null }));
}

export function onlyNumbers(text) {
  text = text?.toString();
  return text?.replace(/\D+/g, "");
}

export function formatNumber(number) {
  number = number?.toString();
  return number?.replace(
    /(?:(^\d{1,3})(?=(?:\d{3})*$)|(\d{3}))(?!$)/gm,
    "$1$2."
  );
}

export function buildFiltersURL(period, startDate, endDate) {
  let url = "?";
  if (period) url = url.concat(`period=${period}&`);
  if (startDate) url = url.concat(`startDate=${startDate}&`);
  if (endDate) url = url.concat(`endDate=${endDate}&`);
  return url;
}

export function getParameterFromURL(param) {
  return new URLSearchParams(window.location.search).get(param);
}

/**
 * It builds an array of dates. The range of dates is determined by the dates passed as params.
 * The range begins with the oldest date and ends with the newest date.
 * Example: ["01/01/2000", ......., "31/12/2000"] OR ["01/2000", ......., "12/2000"]
 * @param {*} oldestDate
 * @param {*} newestDate
 * @param {*} isMonth
 * @returns Array of dates
 */
export function buildArrayOfDates(oldestDate, newestDate, period) {
  const isMonth = period === "MONTH";
  const isWeek = period === "WEEK";
  const timeRange = isMonth ? "months" : isWeek ? "weeks" : "days";
  let dates = [];
  const diff = moment(new Date(newestDate)).diff(
    new Date(oldestDate),
    timeRange
  );

  for (let index = 0; index <= diff; index++) {
    const newDate = moment(oldestDate)
      .add(index, timeRange)
      .format(isMonth ? "YYYY-MM" : "YYYY-MM-DD");
    dates?.push(newDate);
  }
  return dates;
}

/**
 * It creates an chart subtitle object. Each key in the object is a data type.
 * Data Types can be:
 *
 *      fcp, lcp, fid, cls, performance (WebVitals)
 *                    OR
 *      clicks, impressions, ctr, position (Google Search Console).
 *
 * Something like this will be returned to you:
 *
 * {cls: [...], fcp: [...], fid: [...], lcp: [...], performance: [...]}
 *
 * @param {*} dataTypes
 * @param {*} generateLabels
 * @returns A chartSubtitles object with the dataTypes as key of that object
 */
export function createChartSubtitles(dataTypes, generateLabels) {
  let chartSubtitles = {};
  dataTypes?.forEach((type) => (chartSubtitles[type] = [generateLabels(type)]));
  return chartSubtitles;
}

export function formatDate(isMonth, date, withWeekDay) {
  let ret = moment(date).format(isMonth ? "MM/YY" : "DD/MM/YY");
  if (withWeekDay && !isMonth) {
    const weekday = daysOfTheWeek[moment(date).day()];
    ret = ret.concat(` ${weekday}`);
  }
  return ret;
}

export function userHasRole(roles, showErrorMessage) {
  const userIsLogged = store?.getState()?.user?.token?.length > 0;
  const userRoles = store?.getState()?.user?.data?.roles;
  const hasRole = userRoles?.find((item) => roles?.includes(item.role));

  if (userIsLogged) {
    if (!hasRole && showErrorMessage)
      showToast("Você não possui permissão para acessar esta página.", "error");
    return hasRole;
  }
}

export function perc(value, sum) {
  return (value * 100) / sum;
}